import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";
import { Link } from "react-router-dom";

const toTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

function Returns() {
  return (
    <div className="delivery">
      <Header />
      <div className="section-stack">
        <div className="section-header justify-self-center text-center">
          <h1 className="h2">Order Policy</h1>
        </div>
        <div id="dynamic-rows" className="prose">
          <div className="row-inner">
            <h3>SHIPPING</h3>
            <p className="p1">
              <span className="s1">
                We offer complimentary standard shipping on domestic orders over
                €250. Standard shipping for orders under €250 is €9.00.{" "}
              </span>
            </p>
            <p className="p1">
              <span className="s1">
                Expedited shipping is available for an added fee; c
              </span>
              alculated&nbsp;rates for&nbsp;shipping options will be
              shown&nbsp;at checkout with estimated shipping times (these times
              do not include order processing, which may&nbsp;take 1-3 business
              days).
            </p>
            <p className="p1">
              <span className="s1">
                All orders are shipped out of our warehouse&nbsp;Monday through
                Friday. Because the nature of a small team, some orders will
                take between 1-3 days of processing before they are ready for
                shipment. Once they’ve been shipped, most orders take between
                3-5 business days to arrive at your door. Please allow more time
                for processing during holidays and peak sale days. We will do
                our best to provide you with accurate shipping information
                during those times.
              </span>
            </p>
            <p className="p1">&nbsp;&nbsp;</p>
            <p className="p1">&nbsp;</p>
            <p className="p1">&nbsp;</p>
          </div>
          <div className="row--columns">
            <h3>RETURNS &amp; EXCHANGES</h3>
            <p>
              <span style={{ fontWeight: 400 }}>
                We gladly offer domestic returns &amp; exchanges on any
                regularly priced, unworn, unwashed merchandise within 14 days of
                the delivery date. You will need your order number which can be
                found on your packing slip.
              </span>
            </p>
            <p>
              <Link onClick={toTop} to="/">
                <span style={{ fontWeight: 400 }}>
                  CLICK HERE TO INITIATE YOUR RETURN / EXCHANGE
                </span>
              </Link>
            </p>
            <p>
              <span style={{ fontWeight: 400 }}>
                All items noted as Final Sale in the item description and/or
                sales promotion are not eligible for return. We reserve the
                right to refuse any returned item that does not meet our refund
                policy.
              </span>
            </p>
            <p>
              <span style={{ fontWeight: 400 }}>
                Returns will be approved on eligible items automatically, and
                you’ll be provided a return label for all US-based orders. If
                you’ve selected an item in exchange, your new item will ship in
                1-3 business days.&nbsp;
              </span>
            </p>
            <p>
              <meta charSet="utf-8" />
              <meta charSet="utf-8" />
              <span>
                Returns will be refunded to the original method of payment.
                Returns for store credit will receive a credit for the full
                value of the returned item. Your store credit will never expire
                and can be used toward anything on our site.&nbsp;
              </span>
            </p>
            <p dir="ltr">
              <em>Redo Free Returns</em>
            </p>
            <p role="presentation" dir="ltr">
              <em>
                By selecting Redo Free Returns at checkout, your return shipping
                label is covered.
              </em>
            </p>
            <p role="presentation" dir="ltr">
              <em>
                Redo Free Returns cannot be removed once the order has been
                placed.
              </em>
            </p>
            <p role="presentation" dir="ltr">
              <em>
                If you don’t add Redo Free Returns at checkout, you’ll be
                responsible for the cost of the return shipping label.
              </em>
            </p>
            <p>
              <span style={{ fontWeight: 400 }}>
                Returning a gift? Visit our&nbsp;
              </span>
              <span style={{ fontWeight: 400 }}>
                <Link onClick={toTop} to="/returns">
                  Returns Center
                </Link>
              </span>
              <span style={{ fontWeight: 400 }}>
                {" "}
                and select “Return a Gift” below the email entry box. You’ll
                then be guided through the exchange process, receive a return
                shipping label, and an order confirmation for your new
                replacement order.
              </span>
            </p>
            <p>
              <span style={{ fontWeight: 400 }}>
                You’re welcome to contact us to return or exchange your
                order.&nbsp; Just email us at{" "}
              </span>
              <Link onClick={toTop} to="mailto:main@ownmarketplace.xyz">
                <span style={{ fontWeight: 400 }}>main@ownmarketplace.xyz</span>
              </Link>
            </p>
            <h3 className="space-top-title">INTERNATIONAL ORDERS</h3>
            <p>
              <span style={{ fontWeight: 400 }}>
                We ship worldwide via UPS or DHL Worldwide Express, with USPS
                International Priority Mail available in select regions.
                Shipping rates are calculated by the carrier. Calculated rates
                and shipping options will be shown at checkout, with estimated
                shipping times (these times do not include order processing,
                which can take 1-3 business days). International shipping rates{" "}
              </span>
              <i>
                <span style={{ fontWeight: 400 }}>do not</span>
              </i>
              <span style={{ fontWeight: 400 }}>
                {" "}
                include local taxes or duties. International customers are
                responsible for any additional costs imposed by the local
                government upon delivery. To calculate your expected cost, use
                the link below and enter 620449 as the harmonized code:{" "}
              </span>
              <Link onClick={toTop} to="/">
                <span style={{ fontWeight: 400 }}>
                  www.simplyduty.com/import-calculator
                </span>
              </Link>
            </p>
            <p>
              <span style={{ fontWeight: 400 }}>
                Ownmarketplace is not responsible for any charges incurred for
                refused packages. In the case that the package is refused, the
                total cost of the return fees will be deducted from your refund.
                Refunds will only be issued if the products are returned to
                Ownmarketplace. Original shipping charges will not be refunded.
              </span>
            </p>
            <p>
              <span style={{ fontWeight: 400 }}>
                International returns are accepted on all regularly priced,
                unworn, unwashed merchandise. Return package must be in transit
                back to us within 14 days of delivery date.{" "}
                <meta charSet="utf-8" />{" "}
                <span>
                  All items noted as Final Sale in the item description and/or
                  sales promotion are not eligible for return.
                </span>{" "}
                We reserve the right to refuse any returned item that does not
                meet our refund policy. Refunds are issued to your original
                method of payment.&nbsp;
              </span>
            </p>
            <p>
              <span style={{ fontWeight: 400 }}>Please visit our </span>
              <span style={{ fontWeight: 400 }}>
                <Link onClick={toTop} to="/returns">
                  Returns Center
                </Link>
              </span>
              <span style={{ fontWeight: 400 }}>
                {" "}
                to initiate your return. You will be given a Return
                Authorization and address for return. Please package our return
                and take it to your preferred mail carrier— we recommend using a
                trackable shipping method. We are not responsible for returned
                items lost or damaged in transit.
              </span>
            </p>
            <p className="p1">&nbsp;</p>
            <h3>SHIPPING CONFIRMATIONS</h3>
            <p>
              <span className="s1">
                Once you’ve placed your order, you will&nbsp;receive
                a&nbsp;confirmation email with tracking. Please ensure that your
                shipping address is a secure location. We are not responsible
                for lost or stolen packages, or packages damaged in transit.
              </span>
            </p>
            <p className="p1">
              <span className="s1">
                Need Assistance? We'd love to help.&nbsp; Please contact us at{" "}
                <Link onClick={toTop} to="mailto:main@ownmarketplace.xyz">
                  main@ownmarketplace.xyz
                </Link>
              </span>
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Returns;
